import { IAddressData, ILocationData } from "./AddressMapHelper";
import { AdvancedMarker, Pin } from "@vis.gl/react-google-maps";
import theme from "../../theme";

type IAddressMapMarker = {
  addressData: IAddressData | ILocationData;
  onDragEnd: (data: any) => Promise<void>;
};

function AddressMapMarker({ addressData, onDragEnd }: IAddressMapMarker) {
  return (
    <AdvancedMarker
      position={{ lat: addressData.lat, lng: addressData.lng }}
      draggable={true}
      onDragEnd={onDragEnd}
      data-testid="address-marker"
    >
      <Pin
        background={theme.palette.primary.main}
        borderColor={theme.palette.secondary.main}
        glyphColor={theme.palette.common.white}
      />
    </AdvancedMarker>
  );
}

export default AddressMapMarker;
